@if (label) {
  <span class="lbl">{{ label }}&nbsp;:</span>
}
<div class="dd">
  <button
    type="button"
    class="dd-btn"
    (click)="toggle()"
    [attr.aria-expanded]="open"
  >
    {{ currentLabel }}
    <svg viewBox="0 0 10 7" width="10" height="7" aria-hidden="true">
      <path
        d="M1 1l4 4 4-4"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  </button>
  @if (open) {
    <ul class="dd-menu" role="listbox">
      @for (o of options; track o.key) {
        <li role="option" [class.sel]="value === o.key" (click)="pick(o.key)">
          {{ o.label }}
        </li>
      }
    </ul>
  }
</div>
